import React, { useEffect, useState } from "react";
import "./style.css";
import { assessmentIcons } from "../../../../../utils/assessmentIcons";
import { Image } from "antd";

const MethodReference = ({
  onFullScreen,
  imageContainerRef,
  data,
  onChangeItem,
  currentStageIndex,
}) => {
  const [tab, setTab] = useState(0); // 0 = Diagram, 1 = Radiograph

  // State for zoom and rotation
  const [zoomLevel, setZoomLevel] = useState(100);
  const [rotationAngle, setRotationAngle] = useState(0);
  const [currentIndex, setCurrentIndex] = useState(currentStageIndex);

  // Add handlers for zoom and rotate
  const handleZoomIn = () => {
    setZoomLevel((prev) => Math.min(prev + 20, 200));
  };

  const handleZoomOut = () => {
    setZoomLevel((prev) => Math.max(prev - 20, 40));
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) => {
      const newIndex = prevIndex < data.length - 1 ? prevIndex + 1 : 0;
      onChangeItem(newIndex); // Pass the new index to the function
      return newIndex;
    });
  };

  const handleBack = () => {
    setCurrentIndex((prevIndex) => {
      const newIndex = prevIndex > 0 ? prevIndex - 1 : data.length - 1;
      onChangeItem(newIndex); // Pass the new index to the function
      return newIndex;
    });
  };

  return (
    <div className="method_reference_container">
      <div className="method_reference_body">
        <div className="_header">
          <p>Reference Guide</p>
          <div className="_header_tabs">
            <div
              onClick={() => setTab(0)}
              className="_tab"
              style={{ background: tab === 0 ? "#FFFFFF" : "" }}
            >
              <img src={assessmentIcons.diagram} /> <p>Diagram</p>
            </div>
            <div
              onClick={() => setTab(1)}
              className="_tab"
              style={{ background: tab === 1 ? "#FFFFFF" : "" }}
            >
              <img src={assessmentIcons.radiograph} /> <p>Radiograph</p>
            </div>
          </div>
        </div>
        <div className="_main">
          <div className="_gallery">
            <img
              src={assessmentIcons.leftArrow}
              className="_left"
              onClick={handleBack}
            />
            <img
              key={currentIndex}
              src={
                tab === 0
                  ? data[currentIndex]?.diagram
                  : data[currentIndex]?.radiograph
              }
              className="full_image fade-in"
              ref={imageContainerRef}
              style={{
                transform: `scale(${
                  zoomLevel / 100
                }) rotate(${rotationAngle}deg)`,
                transition: "transform 0.3s ease",
              }}
            />
            <img
              src={assessmentIcons.rightArrow}
              className="_right"
              onClick={handleNext}
            />
          </div>
        </div>
        <div className="_footer">
          <div className="_footer_options">
            <img src={assessmentIcons.zoomIn} onClick={handleZoomIn} />
            <img src={assessmentIcons.zoomOut} onClick={handleZoomOut} />
          </div>
          <img src={assessmentIcons.fullView} onClick={onFullScreen} />
        </div>
      </div>
    </div>
  );
};

export default MethodReference;
